import React from "react";
import styled from "styled-components";
import intl from "react-intl-universal";
import { mdiDownload } from "@mdi/js";

import commonUtils from "../../script/utils/commonUtils";

import { Layout } from "../containers/Layout";
import { Button } from "../components/Button";
import { PdfPage } from "../components/PdfPage";
import { ContentBody } from "../containers/ContentBody";
import { ContentHeader } from "../containers/ContentHeader";

const DocumentStyle = styled.div`
    width: 1000px;
    margin: 0 auto;
`;

export const Document = props => {
    const { title, url } = props;

    const onDownload = () => commonUtils.download(url, title + ".pdf");

    return (
        <Layout>
            <ContentHeader title={title} >
                <Button
                    simulateLoading
                    svgIcon={mdiDownload}
                    value={intl.get("common.download")}
                    onClick={onDownload} />
            </ContentHeader>
            <ContentBody>
                <DocumentStyle>
                    <PdfPage url={url} loadingText={intl.get("document.loadingText")} />
                </DocumentStyle>
            </ContentBody>
        </Layout>
    );
};